export var UserEventType;
(function (UserEventType) {
    UserEventType["IntegrationUserSignup"] = "integrationUserSignup";
    UserEventType["TempUserSignup"] = "tempUserSignup";
    UserEventType["TempUserConfirmEmail"] = "tempUserConfirmEmail";
    UserEventType["SocialSSOSignUp"] = "socialSSOSignUp";
    UserEventType["CognitoSignup"] = "cognitoSignup";
    UserEventType["CognitoSocialSignup"] = "cognitoSocialSignup";
    UserEventType["CognitoEnterpriseSignup"] = "cognitoEnterpriseSignup";
})(UserEventType || (UserEventType = {}));
//# sourceMappingURL=userEventType.js.map